import emojiRegex from "emoji-regex";

export const getComponentTemplateTitle = (title: string) =>
  title.replace(new RegExp(`${emojiRegex().source} *`), "");
